import { render } from "./Glow19Project.vue?vue&type=template&id=f3d54550&scoped=true"
const script = {}

import "./Glow19Project.vue?vue&type=style&index=0&id=f3d54550&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3d54550"]])

export default __exports__